import React from 'react';
import { useParams } from 'react-router-dom';
import { track } from '../tracking/mixpanel';

export default function AbhaLinkComplete() {
    const params: { abhaid: string } = useParams();
    // on mobile safari the url is appended with a ? and some other stuff
    // browser is not able to split query params
    const abhaid = params.abhaid.split('?')[0];

    const url = new URL(window.location.href);
    const forwardUrl = url.searchParams.get('forwardUrl');
    const magicLink = url.searchParams.get('magicLink');

    return (
        <div
            style={{
                padding: '64px 0',
                overflow: 'scroll',
                height: '100vh',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                gap: 12,
            }}
        >
            <span
                style={{ padding: 16, background: '#19A66A', display: 'flex', borderRadius: '50%' }}
            >
                <svg
                    style={{ height: 32, width: 32, fill: 'white' }}
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 448 512"
                >
                    <path d="M438.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 338.7 393.4 105.4c12.5-12.5 32.8-12.5 45.3 0z" />
                </svg>
            </span>
            <p style={{ fontSize: 20, fontWeight: 700, margin: 0 }}>
                Your ABHA is successfully created!
            </p>
            <p style={{ fontSize: 14, fontWeight: 700, margin: 0 }}>Abha Id: {abhaid ?? ''}</p>

            <div className="p-16 space-y-16 flex flex-col items-center">
                {forwardUrl && (
                    <button
                        onClick={() => window.open(forwardUrl)}
                        className="px-16 py-10 primary-btn btn"
                    >
                        View Prescription
                    </button>
                )}
                <button
                    className={`px-16 py-10 ${
                        forwardUrl ? 'secondary-btn' : 'primary-btn'
                    }  space-x-8 btn`}
                    onClick={() => {
                        track('ABHA_BULK_APP_INSTALL', {
                            abhaid: abhaid ?? '',
                            magicLink: ((magicLink || '')?.length > 0 || false).toString(),
                        });
                        window.open(magicLink?.trim() || 'https://eka.im/download', '_blank');
                    }}
                >
                    <svg
                        width="14"
                        height="14"
                        viewBox="0 0 13 12"
                        className={`${!forwardUrl ? 'fill-white' : 'fill-actionPrimary'}`}
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path d="M11 7.125C11.8203 7.125 12.5 7.80469 12.5 8.625V10.5C12.5 11.3438 11.8203 12 11 12H2C1.15625 12 0.5 11.3438 0.5 10.5V8.625C0.5 7.80469 1.15625 7.125 2 7.125H3.24219L4.36719 8.25H2C1.78906 8.25 1.625 8.4375 1.625 8.625V10.5C1.625 10.7109 1.78906 10.875 2 10.875H11C11.1875 10.875 11.375 10.7109 11.375 10.5V8.625C11.375 8.4375 11.1875 8.25 11 8.25H8.60938L9.73438 7.125H11ZM10.625 9.5625C10.625 9.89062 10.3672 10.125 10.0625 10.125C9.73438 10.125 9.5 9.89062 9.5 9.5625C9.5 9.25781 9.73438 9 10.0625 9C10.3672 9 10.625 9.25781 10.625 9.5625ZM6.10156 8.64844L2.89062 5.46094C2.65625 5.25 2.65625 4.89844 2.89062 4.66406C3.10156 4.45312 3.45312 4.45312 3.6875 4.66406L5.9375 6.91406V0.5625C5.9375 0.257812 6.17188 0 6.5 0C6.80469 0 7.0625 0.257812 7.0625 0.5625V6.91406L9.28906 4.6875C9.5 4.45312 9.85156 4.45312 10.0625 4.6875C10.2969 4.89844 10.2969 5.25 10.0625 5.46094L6.875 8.64844C6.78125 8.76562 6.64062 8.8125 6.5 8.8125C6.33594 8.8125 6.19531 8.76562 6.10156 8.64844Z" />
                    </svg>
                    <span>{magicLink?.trim() ? 'View' : 'Download'} ABHA card on Eka.care</span>
                </button>
            </div>
        </div>
    );
}
